import { baseUrl } from "../../../axiosStrapi";
import axiosStrapiInstance from "../../../axiosStrapi";

export async function getHomeContent(){
    return await axiosStrapiInstance.get("/").then((res)=>{console.log('hello')}).catch((err)=>{
        throw err;
    })
}